import { storedStatusRows } from '../compile/creature-status-reader.js';
import { heldLayerlessDefinition } from '../compile/held-definition.js';

type Row = Record<string, unknown>;
const record = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;
const scalar = (value: unknown): unknown => Array.isArray(value) ? value[0] : value;

/** Active target statuses only; mirrors creature_item_arr_has_blocking_status_flag. */
export function statusPreventsActions(caster: Row, read: {
  definition: (id: string) => Row | null;
  value: (row: Row, name: string) => unknown;
}, flag: 'no_actions' | 'no_reactions' = 'no_actions'): boolean {
  return storedStatusRows(caster, 'target').some(value => {
    const status = record(value);
    if (!status || Number(scalar(status.status_private) ?? 0) !== 0) return false;
    if (['year', 'month', 'day', 'hour', 'minute', 'second'].some(part => {
      const paused = scalar(status[`status_paused_campaign_${part}`]);
      return paused != null && paused !== '' && Number(paused) !== 0;
    })) return false;
    const embedded = record(status.status_arr);
    const definition = heldLayerlessDefinition(embedded) ? embedded
      : read.definition(String(scalar(status.status_item_id) ?? record(embedded?.items)?.item_id ?? status.status_arr ?? ''));
    return definition !== null && Number(read.value(definition, flag) ?? 0) !== 0;
  });
}
